import { Checkbox } from '@infotech-soe/erp-ui-kit';
import { DatasetStyleRuleValue } from '@infotech-soe/metaschema';
import React, { memo, useCallback } from 'react';
import { useIntl } from 'react-intl';

import { messages } from './messages';
import { InputConditionsProps, InputName } from './types';

interface Props extends Pick<InputConditionsProps<boolean>, 'onChange'> {
  value: DatasetStyleRuleValue;
}

const PresenceValueCheckboxes = ({
  value,
  onChange,
}: Props): React.JSX.Element => {
  const { formatMessage } = useIntl();

  const handleChange = useCallback(
    (v: boolean, n: string) => {
      if (v) {
        const otherName =
          n === InputName.EMPTY ? InputName.NOTEMPTY : InputName.EMPTY;
        onChange(false, otherName);
        onChange(null, InputName.BEFORE);
        onChange(null, InputName.AFTER);
      }
      onChange(v, n);
    },
    [onChange]
  );

  return (
    <div className="row items-start gutter-x-xl m-mb-md">
      <Checkbox
        label={formatMessage(messages.emptyValue)}
        name={InputName.EMPTY}
        value={value.empty}
        onChange={handleChange}
      />
      <Checkbox
        label={formatMessage(messages.notEmptyValue)}
        name={InputName.NOTEMPTY}
        value={value.notEmpty}
        onChange={handleChange}
      />
    </div>
  );
};

export default memo(PresenceValueCheckboxes);
